import React, { Component } from "react";
import {
  message,
  Spin,
  Row,
  Col,
  Select,
  Divider,
  Alert,
  Input,
} from "antd";
import { SettingOutlined, MailOutlined, CheckCircleOutlined, ApiOutlined } from "@ant-design/icons";
import {
  ButtonItem,
  ErrorItem,
  Form,
  FormItem,
  SwitchItem,
  TextAreaItem,
  SelectItem,
  InputItem,
  TextosDinamicosItem,
  DynamicRecordatoriosList,
  SidebarMenu
} from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import { PlusOutlined, MinusCircleOutlined } from "@ant-design/icons";

const { Option } = Select;

// Variables dinamicas para los textos en los recordatorios
const TEXTOS_EMPLEADOS = [
  { key: "{documento}", desc: "Muestra el nombre y tipo de documento." },
  { key: "{dias}", desc: "Muestra los días restantes para el vencimiento." },
  {
    key: "{fecha}",
    desc: "Muestra la fecha exacta de vencimiento (DD/MM/YYYY).",
  },
];

const TEXTOS_PAGOS = [
  { key: "{poliza}", desc: "Muestra información genérica de la póliza." },
  {
    key: "{dias}",
    desc: "Muestra los días restantes para el pago/vencimiento.",
  },
  { key: "{fecha}", desc: "Muestra la fecha exacta (DD/MM/YYYY)." },
];

// ── Definición del menú ────────────────────────────────────────────────────
const MENU_ITEMS = [
  { key: "general",      icon: <SettingOutlined />, label: "General" },
  { key: "cuentaEnvio", icon: <ApiOutlined />,     label: "Cuenta de Envío", disabled: true },
  { key: "pagos",        icon: <MailOutlined />,    label: "Recordatorios de Pagos" },
  { key: "empleados",    icon: <MailOutlined />,    label: "Recordatorios de Empleados" },
  { key: "prox",         icon: <MailOutlined />,    label: "Próximamente", disabled: true },
];

const SECTION_TITLES = {
  general:      "General",
  cuentaEnvio: "Cuenta de Envío",
  pagos:        "Recordatorios de Pagos",
  empleados:    "Recordatorios de Empleados",
  prox:         "Próximamente",
};

class CorreoConfiguracion extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    testLoading: false,
    habilitado: false,
    objetoUsuarios: null,
    proveedorCorreo: null,
    tipoConexion: null,
    tipoOutlook: null,
    oauthConectado: false,
    oauthEmail: '',
    tieneDatosBancarios: false,
  };
  componentDidMount() {
    this.consultarConfiguracion();
    this.consultarUsuarios();
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "empresas/editarConfiguracionCorreos",
        { ...values, empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se ha modificado la configuracion de la empresa");
          this.consultarConfiguracion();
        } else if (res.data.success === 1) {
          message.error("No se pudo modificar la configuracion");
        } else {
          message.error("Hubo un error y no se modifico la configuracion");
        }
      });
  }

  async consultarConfiguracion() {
    this.setState({ loading: true });
    await axios
      .post(
        "empresas/selectConfiguracionCorreos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status === 404) {
          message.error("Error no se encontro configuracion de esta empresa");
        } else {
          this.formRef.current.setFieldsValue({
            ...res.data,
            datosBancariosCorreo: res.data.datosBancariosCorreo || "no",
          });
          this.setState({
            habilitado: res.data.correo,
            proveedorCorreo: res.data.cuentaEnvio?.proveedor || null,
            tipoConexion: res.data.cuentaEnvio?.tipoConexion || null,
            tipoOutlook: res.data.cuentaEnvio?.tipoOutlook || null,
            oauthConectado: res.data.oauthConectado || false,
            oauthEmail: res.data.oauthEmail || '',
            tieneDatosBancarios: !!res.data.tieneDatosBancarios,
          });
        }
      });
    this.setState({ loading: false });
  }
 
    async consultarUsuarios() {
    await axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.status !== 404) {
          this.setState({
            objetoUsuarios: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre +
                    " " +
                    value.apellidoPaterno +
                    " " +
                    value.apellidoMaterno}
                </Option>
              );
            }),
          });
        }
      });
  }

  handleOAuthConnect = (proveedor) => {
    const { empresaId } = this.props;
    const provider = proveedor === 'gmail' ? 'google' : 'microsoft';
    let url = `/erp/api/auth/${provider}/init?empresaId=${empresaId}`;

    if (process.env.NODE_ENV === "development"){
      url = `http://localhost:3001/erp/api/auth/${provider}/init?empresaId=${empresaId}`;
    }

    const popup = window.open(url, 'oauthPopup', 'width=600,height=700,scrollbars=yes,resizable=yes');

    const handleMessage = (event) => {
      if (event.data?.type === 'oauth_result') {
        window.removeEventListener('message', handleMessage);
        clearInterval(checkClosed);
        if (event.data.success) {
          this.setState({ oauthConectado: true, oauthEmail: event.data.email });
          message.success('Cuenta conectada correctamente');
        } else {
          message.error('No se pudo conectar: ' + (event.data.error || 'Error desconocido'));
        }
      }
    };

    window.addEventListener('message', handleMessage);

    const checkClosed = setInterval(() => {
      if (!popup || popup.closed) {
        clearInterval(checkClosed);
        window.removeEventListener('message', handleMessage);
      }
    }, 1000);
  }

  probarConexion = () => {
    const { empresaId, headersToken } = this.props;
    const cuentaEnvio = this.formRef.current.getFieldValue('cuentaEnvio');
    this.setState({ testLoading: true });
    axios
      .post('empresas/probarConexionCorreo', { empresaId, cuentaEnvio }, { headers: headersToken })
      .then((res) => {
        this.setState({ testLoading: false });
        if (res.data.success === 2) {
          message.success('Conexión exitosa. Se envió un correo de prueba a tu dirección.');
        } else {
          message.error('No se pudo conectar: ' + (res.data.err || 'Error desconocido'));
        }
      });
  }

  handleOAuthDisconnect = () => {
    const { empresaId, headersToken } = this.props;
    this.setState({ loading: true });
    axios
      .post('auth/desconectarCorreo', { empresaId }, { headers: headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({ oauthConectado: false, oauthEmail: '' });
          message.success('Cuenta desconectada');
        } else {
          message.error('No se pudo desconectar la cuenta');
        }
      });
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onValuesChange = (changedValues) => {
    if ("correo" in changedValues) {
      this.setState({ habilitado: changedValues.correo });
    }
    if (changedValues.cuentaEnvio) {
      const cv = changedValues.cuentaEnvio;
      if (cv.proveedor !== undefined) {
        this.setState({ proveedorCorreo: cv.proveedor, tipoConexion: null, tipoOutlook: null });
        this.formRef.current.setFieldsValue({ cuentaEnvio: { tipoConexion: null, tipoOutlook: null } });
      }
      if (cv.tipoConexion !== undefined) this.setState({ tipoConexion: cv.tipoConexion });
      if (cv.tipoOutlook !== undefined) this.setState({ tipoOutlook: cv.tipoOutlook });
    }
  };

  //Secciones de contenido

  renderCuentaEnvio() {
    const { proveedorCorreo, tipoConexion, oauthConectado, oauthEmail, testLoading } = this.state;
    const labelCol = { span: 10 };
    const wrapperCol = { span: 14 };

    return (
      <Row>
        <Col span={12}>
          <DynamicCardForm
            title="Cuenta de Envío"
            style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
          >
            <FormItem
              label="Proveedor"
              name={["cuentaEnvio", "proveedor"]}
              margin
              labelCol={labelCol}
              wrapperCol={wrapperCol}
            >
              <SelectItem placeholder="Selecciona un proveedor" width="100%">
                <Option value="gmail">Gmail</Option>
                <Option value="outlook">Outlook / Microsoft 365</Option>
                <Option value="smtp">SMTP Personalizado</Option>
              </SelectItem>
            </FormItem>

            {/* ── Gmail ──────────────────────────────────────── */}
            {proveedorCorreo === 'gmail' && (
              <>
                <FormItem
                  label="Tipo de Conexión"
                  name={["cuentaEnvio", "tipoConexion"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <SelectItem placeholder="Selecciona" width="100%">
                    <Option value="oauth2">OAuth2 (Recomendado)</Option>
                    <Option value="password">Contraseña de Aplicación</Option>
                  </SelectItem>
                </FormItem>

                {tipoConexion === 'oauth2' && (
                  oauthConectado
                    ? (
                      <>
                        <Alert
                          message={<>Conectado como <strong>{oauthEmail}</strong></>}
                          type="success"
                          showIcon
                          icon={<CheckCircleOutlined />}
                          style={{ marginBottom: 12 }}
                        />
                        <ButtonItem danger onClick={this.handleOAuthDisconnect}>
                          Desconectar cuenta
                        </ButtonItem>
                      </>
                    )
                    : (
                      <ButtonItem onClick={() => this.handleOAuthConnect('gmail')}>
                        Conectar con Google
                      </ButtonItem>
                    )
                )}

                {tipoConexion === 'password' && (
                  <>
                    <Alert
                      message="Genera una contraseña de aplicación en tu cuenta de Google (Seguridad → Contraseñas de aplicación)."
                      type="info"
                      showIcon
                      style={{ marginBottom: 12 }}
                    />
                    <FormItem
                      label="Correo"
                      name={["cuentaEnvio", "usuario"]}
                      margin
                      labelCol={labelCol}
                      wrapperCol={wrapperCol}
                    >
                      <InputItem placeholder="tucorreo@gmail.com" />
                    </FormItem>
                    <FormItem
                      label="Contraseña de Aplicación"
                      name={["cuentaEnvio", "password"]}
                      margin
                      labelCol={labelCol}
                      wrapperCol={wrapperCol}
                    >
                      <Input.Password placeholder="xxxx xxxx xxxx xxxx" />
                    </FormItem>
                  </>
                )}
              </>
            )}

            {/* ── Outlook ────────────────────────────────────── */}
            {proveedorCorreo === 'outlook' && (
              <>
                <FormItem
                  label="Tipo de cuenta"
                  name={["cuentaEnvio", "tipoOutlook"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <SelectItem placeholder="Selecciona" width="100%">
                    <Option value="personal">Personal (@outlook, @hotmail)</Option>
                    <Option value="empresarial">Empresarial (Microsoft 365)</Option>
                  </SelectItem>
                </FormItem>

                <FormItem
                  label="Tipo de Conexión"
                  name={["cuentaEnvio", "tipoConexion"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <SelectItem placeholder="Selecciona" width="100%">
                    <Option value="oauth2">OAuth2 (Recomendado)</Option>
                    <Option value="password">Contraseña / App Password</Option>
                  </SelectItem>
                </FormItem>

                {tipoConexion === 'oauth2' && (
                  oauthConectado
                    ? (
                      <>
                        <Alert
                          message={<>Conectado como <strong>{oauthEmail}</strong></>}
                          type="success"
                          showIcon
                          icon={<CheckCircleOutlined />}
                          style={{ marginBottom: 12 }}
                        />
                        <ButtonItem danger onClick={this.handleOAuthDisconnect}>
                          Desconectar cuenta
                        </ButtonItem>
                      </>
                    )
                    : (
                      <ButtonItem onClick={() => this.handleOAuthConnect('outlook')}>
                        Conectar con Microsoft
                      </ButtonItem>
                    )
                )}

                {tipoConexion === 'password' && (
                  <>
                    <FormItem
                      label="Correo"
                      name={["cuentaEnvio", "usuario"]}
                      margin
                      labelCol={labelCol}
                      wrapperCol={wrapperCol}
                    >
                      <InputItem placeholder="tucorreo@outlook.com" />
                    </FormItem>
                    <FormItem
                      label="Contraseña"
                      name={["cuentaEnvio", "password"]}
                      margin
                      labelCol={labelCol}
                      wrapperCol={wrapperCol}
                    >
                      <Input.Password />
                    </FormItem>
                  </>
                )}
              </>
            )}

            {/* ── SMTP Personalizado ─────────────────────────── */}
            {proveedorCorreo === 'smtp' && (
              <>
                <FormItem
                  label="Host SMTP"
                  name={["cuentaEnvio", "host"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <InputItem placeholder="smtp.ejemplo.com" />
                </FormItem>
                <FormItem
                  label="Puerto"
                  name={["cuentaEnvio", "puerto"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <InputItem type="number" placeholder="587" />
                </FormItem>
                <FormItem
                  label="Seguridad"
                  name={["cuentaEnvio", "seguridad"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <SelectItem width="100%">
                    <Option value="tls">STARTTLS (puerto 587)</Option>
                    <Option value="ssl">SSL/TLS (puerto 465)</Option>
                    <Option value="none">Ninguna (puerto 25)</Option>
                  </SelectItem>
                </FormItem>
                <FormItem
                  label="Usuario"
                  name={["cuentaEnvio", "usuario"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <InputItem placeholder="usuario@dominio.com" />
                </FormItem>
                <FormItem
                  label="Contraseña"
                  name={["cuentaEnvio", "password"]}
                  margin
                  labelCol={labelCol}
                  wrapperCol={wrapperCol}
                >
                  <Input.Password />
                </FormItem>
              </>
            )}

            {proveedorCorreo && (
              <div style={{ marginTop: 16 }}>
                <Divider style={{ margin: "12px 0" }} />
                <ButtonItem
                  loading={testLoading}
                  onClick={this.probarConexion}
                  icon={<CheckCircleOutlined />}
                >
                  Probar Conexión
                </ButtonItem>
              </div>
            )}
          </DynamicCardForm>
        </Col>
      </Row>
    );
  }

  renderGeneral() {
    return (
      <Row>
        <Col span={12}>
          <DynamicCardForm
            title="Mensajes en correo"
            style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
          >
            <FormItem
              label="Activar mensaje en Correo"
              name="correoEnvio"
              pattern
              margin
              tooltip="Se activará el mensaje de envío en los correos que mande desde Biwo ERP"
              valuePropName="checked"
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
            >
              <SwitchItem />
            </FormItem>

            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const mostrar = !!getFieldValue("correoEnvio");
                return (
                  <FormItem
                    label="Mensaje en Correo"
                    name="textoCorreo"
                    pattern
                    margin
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 14 }}
                  >
                    <TextAreaItem
                      placeholder="Mensaje"
                      style={{ width: "100%" }}
                      disabled={!mostrar}
                    />
                  </FormItem>
                );
              }}
            </FormItem>
          </DynamicCardForm>
        </Col>
        <Col span={12}>
          <DynamicCardForm
            title="Datos bancarios en correo"
            style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
          >
            <FormItem
              label="Incluir datos bancarios"
              name="datosBancariosCorreo"
              margin
              tooltip="Aplica a los correos de facturas y remisiones de venta. Los datos se toman de Configuración → Avanzado → Bancos."
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
            >
              <SelectItem width="100%">
                <Option value="no">No incluir</Option>
                <Option value="cuerpo">En el cuerpo del correo</Option>
                <Option value="pdf">PDF adjunto</Option>
                <Option value="ambos">Ambos</Option>
              </SelectItem>
            </FormItem>

            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => {
                const modo = getFieldValue("datosBancariosCorreo");
                if (!modo || modo === "no" || this.state.tieneDatosBancarios) return null;
                return (
                  <Alert
                    message="No hay bancos capturados en Configuración → Avanzado → Bancos; no se agregará nada al correo."
                    type="warning"
                    showIcon
                  />
                );
              }}
            </FormItem>
          </DynamicCardForm>
        </Col>
      </Row>
    );
  }

  renderPagos() {
    return (
      <Row>
        <Col span={12}>
          <DynamicCardForm
            title="Recordatorios de pago de polizas de seguro"
            style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
          >
            <FormItem name="tipo" initialValue="Pago polizas seguro" hidden>
              <InputItem />
            </FormItem>

            <FormItem
              label="Activar Recordatorio"
              name={["pagos", "estado"]}
              valuePropName="checked"
              margin
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
            >
              <SwitchItem />
            </FormItem>

            <FormItem
              label="Usuarios que recibirán el correo"
              name={["pagos", "usuarios"]}
              margin
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
            >
              <SelectItem width="100%" mode="multiple" placeholder="Selecciona a los usuarios">
                {this.state.objetoUsuarios}
              </SelectItem>
            </FormItem>

            <Divider style={{ margin: "12px 0" }}>Avisos Dinámicos</Divider>
            <Alert
              message="Nota sobre estos recordatorios"
              description="Estos avisos dinámicos se evaluarán para cada fecha de pago programada (mensual, bimestral, anual o de pago único) de la póliza."
              type="info"
              showIcon
              style={{ marginBottom: "16px" }}
            />
            <TextosDinamicosItem textos={TEXTOS_PAGOS} />
            <DynamicRecordatoriosList name="pagos" formRef={this.formRef} />
          </DynamicCardForm>
        </Col>
      </Row>
    );
  }

  renderEmpleados() {
    return (
      <Row>
        <Col span={12}>
          <DynamicCardForm
            title="Recordatorio de vencimiento de los documentos de los empleados"
            style={{ margin: "0 auto 12px auto", maxWidth: "98%" }}
          >
            <FormItem name="tipo" initialValue="Vencimiento documentos empleados" hidden>
              <InputItem />
            </FormItem>

            <FormItem
              label="Activar Recordatorio"
              name={["empleados", "estado"]}
              valuePropName="checked"
              margin
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
            >
              <SwitchItem />
            </FormItem>

            <FormItem
              label="Usuarios que recibirán el correo"
              name={["empleados", "usuarios"]}
              margin
              labelCol={{ span: 10 }}
              wrapperCol={{ span: 14 }}
            >
              <SelectItem width="100%" mode="multiple" placeholder="Selecciona a los usuarios">
                {this.state.objetoUsuarios}
              </SelectItem>
            </FormItem>

            <Divider style={{ margin: "12px 0" }}>Avisos Dinámicos</Divider>
            <TextosDinamicosItem textos={TEXTOS_EMPLEADOS} />

            <Form.List
              name={["empleados", "recordatorios"]}
              rules={[
                {
                  validator: async (_, recordatorios) => {
                    const activado = this.formRef.current?.getFieldValue(["empleados", "estado"]);
                    if (activado && (!recordatorios || recordatorios.length < 1)) {
                      return Promise.reject(
                        new Error("¡Si activas el recordatorio, debes poner al menos un aviso!"),
                      );
                    }
                  },
                },
              ]}
            >
              {(fields, { add, remove }, { errors }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <div
                      key={key}
                      style={{
                        marginBottom: 20,
                        padding: 15,
                        border: "1px solid #f0f0f0",
                        borderRadius: 5,
                      }}
                    >
                      <Row gutter={16} align="middle">
                        <Col span={20}>
                          <FormItem
                            {...restField}
                            name={[name, "dias"]}
                            label={`Aviso ${index + 1} (Días antes)`}
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                            rules={[{ required: true, message: "Ingresa los días" }]}
                          >
                            <InputItem type="number" placeholder="Ej. 7" />
                          </FormItem>

                          <FormItem
                            {...restField}
                            name={[name, "mensaje"]}
                            label="Mensaje Personalizado"
                            margin
                            labelCol={{ span: 8 }}
                            wrapperCol={{ span: 16 }}
                          >
                            <TextAreaItem
                              placeholder="Ej. El {documento} vencerá en {dias} días."
                              rows={3}
                              style={{ width: "100%" }}
                            />
                          </FormItem>
                        </Col>
                        <Col span={4} style={{ textAlign: "center" }}>
                          <MinusCircleOutlined
                            style={{ fontSize: "18px", color: "#ff4d4f", cursor: "pointer" }}
                            onClick={() => remove(name)}
                            title="Eliminar aviso"
                          />
                        </Col>
                      </Row>
                    </div>
                  ))}
                  <Row>
                    <Col span={24}>
                      <ButtonItem
                        type="dashed"
                        onClick={() => add()}
                        block
                        icon={<PlusOutlined />}
                      >
                        Añadir Recordatorio
                      </ButtonItem>
                      {errors?.length > 0 && (
                        <div style={{ color: "#ff4d4f", marginTop: "5px", fontSize: "14px" }}>
                          {errors.map((err, i) => <div key={i}>{err}</div>)}
                        </div>
                      )}
                    </Col>
                  </Row>
                </>
              )}
            </Form.List>
          </DynamicCardForm>
        </Col>
      </Row>
    );
  }

  // Render principal

  render() {
    return (
      <Spin spinning={this.state.loading}>
        <Form
          name="correosConfiguracion"
          layout="vertical"
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
          ref={this.formRef}
          loading={this.state.loading}
          onValuesChange={this.onValuesChange}
        >
          <SidebarMenu
            menuItems={MENU_ITEMS}
            sectionTitles={SECTION_TITLES}
            defaultSelected="general"
            headerLabel="Configuración"
            siderWidth={210}
            minHeight={480}
            renderContent={(key) => {
              switch (key) {
                case "general":      return this.renderGeneral();
                case "cuentaEnvio": return this.renderCuentaEnvio();
                case "pagos":        return this.renderPagos();
                case "empleados":    return this.renderEmpleados();
                default:          return null;
              }
            }}
            footer={
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ minWidth: 160, height: 30, display: "flex", alignItems: "center", justifyContent: "center" }}
              >
                Guardar Configuración
              </ButtonItem>
            }
          />
        </Form>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(CorreoConfiguracion);
